//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Positioning.js";
import "../no/NXObject.js";
import "../no/ugmath.js";
let d=[[[0,"ConstraintReferenceHalfSpace",1,0],[0,"GeometryDirectionReversed",1,0],[0,"HelpPoint",1,0],[0,"Order",0,0],[0,"SolverGeometryType",0,0],[0,"UsePortRotateFlag",1,0]],[[[],"GetGeometry",{R_:{geometry:"NXObject"}},0,0],[[],"GetPrototypeGeometry",{R_:{geometry:"NXObject"}},0,0],[[],"GetMovableObject",{R_:{movable_object_id:"NXObject"}},0,0],[[],"GetUsesGeometryAxis",{R_:{geometry:''}},0,0],[["set"],"SetFixHint",{},1,0],[["set"],"SetFixHintForUpdate",{},1,0],[[],"GetUsePortRotate",{R_:{use_rotate:''}},0,0],[[],"GetHasPerpendicularVector",{R_:{has_perpendicular_vector:''}},0,0],[[],"GetPrototypePerpendicularVector",{R_:{perpendicular_vector:''}},0,0],[["perpendicular_vector"],"SetPrototypePerpendicularVector",{},1,0]],[]];
SPLM.Positioning.ConstraintReference = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Positioning.ConstraintReference";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Positioning.ConstraintReference.GeometryType = Object.freeze({
    "Unknown" : "Unknown", "Point" : "Point", "Line" : "Line", "Circle" : "Circle", "Plane" : "Plane", "Cylinder" : "Cylinder", "Sphere" : "Sphere", "SweepSurface" : "SweepSurface", "ParametricSurface" : "ParametricSurface", "ParametricCurve" : "ParametricCurve", "SplineCurve" : "SplineCurve", "Torus" : "Torus", "Cone" : "Cone", "Ellipse" : "Ellipse", "SplineSurface" : "SplineSurface", "CoordinateSystem" : "CoordinateSystem"});

SPLM.Positioning.ConstraintReference.ConstraintOrder = Object.freeze({
    "Unknown" : "Unknown", "Inside" : "Inside", "Outside" : "Outside"});

SPLM.Positioning.ConstraintReference.HalfSpace = Object.freeze({
    "Infer" : "Infer", "Positive" : "Positive", "Negative" : "Negative"});

export default SPLM;